import { Col, Grid, H1, Row } from '@rcl/rcl';
import { useTranslation } from 'react-i18next';

export const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <main>
      <Grid>
        <Col>
          <Row>
            <H1>{t('notFoundPage.title')}</H1>
          </Row>

          <Row>
            <p>{t('notFoundPage.description')}</p>
          </Row>
        </Col>
      </Grid>
    </main>
  );
};
